import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import App from "./App.tsx";

document.documentElement.setAttribute("data-bs-theme", "feebbo");

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
